import styled from 'styled-components'

export const Root = styled.div`
  display: inline-flex;
  align-items: center;
  line-height: 0;
  width: ${({ theme }) => `calc((${theme.size.icon.small} * 3) + (${theme.size.space['03']} * 2))`};
  height: ${({ theme }) => theme.size.icon.small};

  > * {
    display: inline-flex;
    width: 100%;
    height: 100%;
  }

  && .ant-skeleton.ant-skeleton-element,
  && .ant-skeleton.ant-skeleton-element .ant-skeleton-avatar {
    width: 100%;
    min-width: 100%;
    height: 100%;
    line-height: ${({ theme }) => theme.size.icon.small};
  }

  && .ant-skeleton.ant-skeleton-element .ant-skeleton-avatar {
    border-radius: ${({ theme }) => theme.size.border.radius['02']};
  }
`
